export function insertAfterElement(el, referenceNode) {
    var _a;
    return (_a = referenceNode.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(el, referenceNode.nextSibling);
}
